"use strict";
var IfObservable_1 = require('./IfObservable');
exports._if = IfObservable_1.IfObservable.create;
//# sourceMappingURL=if.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src727013012/src/~/rxjs/observable/if.js
// module id = pOTC
// module chunks = 6